import http from './api'
import { GolfScorePayload, GolfScoreResult, GolfSession } from '../types/golfTraining'

class GolfTrainingService {
  async createSession(): Promise<GolfSession> {
    const response = await http.post('/golf/session', { mode: 'training' })
    return response.data
  }

  async recordScore(payload: GolfScorePayload): Promise<GolfScoreResult> {
    const response = await http.post('/golf/score', payload)
    return response.data
  }

  async getLeaderboard(limit = 20): Promise<Array<{ rank: number; userId: string; bestScore: number; avgScore: number; shots: number }>> {
    const response = await http.get('/golf/leaderboard', { params: { limit } })
    return response.data
  }
}

const golfTrainingService = new GolfTrainingService()
export default golfTrainingService

